import { DialogRoot, DialogCustomContent } from "./DialogGeneric.styles";
import React from "react";

export const DialogGeneric = (props) => {
  const { show, onHandleClose, maxWidth, children, sx } = props;

  // Inject onHandleClose into every child (if it's a valid React element)
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onHandleClose });
    }
    return child;
  });

  return (
    <DialogRoot
      fullWidth
      maxWidth={maxWidth}
      open={show}
      onClose={() => onHandleClose(false, "backdropClick")}
      sx={{
        ...sx,
        "& .MuiBackdrop-root": {
          background: "rgba(40,40,35,0.5)",
        },
      }}
    >
      <DialogCustomContent>{childrenWithProps}</DialogCustomContent>
    </DialogRoot>
  );
};
